import React, { useContext, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Spinner
} from 'reactstrap';

import { GoGoal } from 'react-icons/go';
import { FiCommand } from 'react-icons/fi';
import { BiSolidZap } from 'react-icons/bi';
import { useHistory } from 'react-router-dom';
import { MdSupportAgent } from 'react-icons/md';
import { GiArcheryTarget } from 'react-icons/gi';
import { AiOutlinePoweroff } from 'react-icons/ai';
import { RiShoppingBag3Fill } from 'react-icons/ri';
import { getUserData } from '../../../utility/Utils';
import { handleLogout } from '@store/authentication';
import { renderClient } from '../../../utility/Utils';
import { useDispatch, useSelector } from 'react-redux';
import { getFamilyMembersAction } from '../store/action';
import { PiChalkboardTeacherFill } from 'react-icons/pi';
import { SocketContext } from '../../../utility/context/Socket';
import { FaAngleDown, FaFile, FaFileContract, FaTasks, FaUserCircle } from 'react-icons/fa';
import {setProfileTab} from "../tab/Profile/store/reducer";

function MobileProfileNav({
  setProfileTab,
  setIsMobileView,
  profileTab,
  selectedRow,
  setSelectedRow,
  selectedFamilyMemberId,
  setSelectedFamilyMemberId
}) {
  const store = useSelector((state) => state?.socialCommunity);
  const socket = useContext(SocketContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const user = getUserData();
  const location = JSON.parse(localStorage.getItem('location'));
  const contactId = location && location.contactId;

  const logOutFunction = () => {
    const selectedRole = JSON.parse(localStorage.getItem('location'));
    const payload = {
      user: user,
      userId: selectedRole?.assignerId,
      organizationId: selectedRole?.organizationId
    };
    socket.emit('signoutCommunity', payload);
    dispatch(handleLogout());
  };

  const clickHandler = (tabNumber,text) => {
    if (selectedRow !== null) {
      setSelectedRow(null);
    } else {
      setSelectedRow(tabNumber);
      dispatch(setProfileTab(tabNumber));
      //setProfileTab(tabNumber);
      history.push(`?active=${text.toLowerCase()}`)
      setIsMobileView(true);
      if (tabNumber === 13) {
        logOutFunction();
        history.push('/login');
      }
    }
  };

  const getTabName = (tabNumber) => {
    switch (tabNumber) {
      case 2:
        return 'Profile';
      case 3:
        return 'Achievements';
      case 4:
        return 'Goals';
      case 5:
        return 'Files';
      case 6:
        return 'Courses';
      case 7:
        return 'Orders';
      case 8:
        return 'Contracts';
      case 9:
        return 'Tasks';
      case 10:
        return 'Events';
      case 11:
        return 'Leaderboard';
      case 12:
        return 'Support';
      case 13:
        return 'Logout';
      default:
        return '';
    }
  };

  useEffect(() => {
    dispatch(getFamilyMembersAction({ contactId }));
  }, [contactId]);

  const renderRow = (rowNumber, icon, text, iconSize = 20) => (
    <>
      <Col sm={6} className="p-50">
        <Card
          className={`p-1 mb-0 ${profileTab === rowNumber ? 'border-primary' : ''}`}
          onClick={() => clickHandler(rowNumber,text)}
        >
          <div>
            <span className="me-1">
              {icon({ color: profileTab === rowNumber ? 'blue' : '', size: iconSize })}
            </span>
            <span className="fs-5">{text}</span>
          </div>
        </Card>
      </Col>
    </>
  );

  const detailedViewContent = (
    <>
      <div className="d-flex justify-content-between mb-1">
        <div>
          <span className="fs-2 fw-bold">{getTabName(selectedRow)}</span>
        </div>

        {/*<Button color="primary" outline size="sm" onClick={() => {
          setSelectedRow(null)
          history.push()
          }}>
          Back
        </Button>*/}
      </div>
    </>
  );

  return (
    <>
      {selectedRow === null && (
        <div className="mb-0">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div>
                {renderClient({
                  ...store?.profile,
                  contactId: store?.profile?._id,
                  fullName: store?.profile?.fullName,
                  photo: store?.profile?.photo,
                  size: 'md'
                })}
              </div>
              <div>
                <span className="fs-4 fw-bold">
                  {store?.profile?.fullName ? (
                    store?.profile?.fullName
                  ) : (
                    <Spinner color="primary" size="sm" />
                  )}
                </span>
              </div>
            </div>
            <div>
              <UncontrolledButtonDropdown className="dropdown-sort  ms-auto">
                <DropdownToggle className="text-capitalize" color="primary" outline caret>
                  {store?.familyMembers?.find((x) => x?._id === selectedFamilyMemberId)?.fullName}
                </DropdownToggle>
                <DropdownMenu container="body">
                  {store?.familyMembers?.length !== 0 ? (
                    store?.familyMembers?.map((item) => {
                      return (
                        <DropdownItem
                          className="w-100"
                          key={item?._id}
                          onClick={() => setSelectedFamilyMemberId(item?._id)}
                        >
                          {item.fullName}
                        </DropdownItem>
                      );
                    })
                  ) : (
                    <DropdownItem className="w-100">No Items</DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          </div>
        </div>
      )}

      {selectedRow === null ? (
        <div className="m-50">
          <Row className="mb-1">
            {renderRow(2, FaUserCircle, 'Profile')}
            {renderRow(8, FaFileContract, 'Contracts')}
            {renderRow(10, BiSolidZap, 'Events')}
            {renderRow(7, RiShoppingBag3Fill, 'Orders')}
            {renderRow(6, PiChalkboardTeacherFill, 'Courses')}
            {renderRow(9, FaTasks, 'Tasks')}
            {renderRow(4, GoGoal, 'Goals')}
            {renderRow(13, AiOutlinePoweroff, 'Logout')}
          </Row>
        </div>
      ) : (
        detailedViewContent
      )}
    </>
  );
}

export default MobileProfileNav;
